export default "/icon-copy.svg";